(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-size-guide-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        document.documentElement.classList.add('size-guide-open');
      }
      return;
    }
    if (event.target.closest('[data-size-guide-close]')) {
      var openDialog = event.target.closest('dialog');
      if (openDialog) openDialog.close();
      return;
    }
    if (event.target.matches && event.target.matches('dialog.size-guide__dialog')) {
      event.target.close();
    }
  });
  document.addEventListener('close', function (event) {
    if (event.target.matches && event.target.matches('dialog.size-guide__dialog')) {
      document.documentElement.classList.remove('size-guide-open');
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
